import React from 'react';
import { FileText, Briefcase, Building2, Calculator, RefreshCw, Calendar, Shield } from 'lucide-react';
import { mockServices } from '../mock';

const iconMap = {
  FileText: FileText,
  Briefcase: Briefcase,
  Building2: Building2,
  Calculator: Calculator,
  RefreshCw: RefreshCw,
  Calendar: Calendar,
  Shield: Shield
};

const ServiceCard = ({ service }) => {
  const IconComponent = iconMap[service.icon];
  
  return (
    <div
      className="hover-lift"
      style={{
        background: 'var(--bg-primary)',
        border: '1px solid var(--border-light)',
        borderRadius: '0px',
        padding: '40px 32px',
        cursor: 'default',
        position: 'relative',
        overflow: 'hidden',
        transition: 'all 0.3s ease'
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.borderColor = 'var(--accent-gold)';
        e.currentTarget.style.boxShadow = '0 8px 30px rgba(212, 175, 55, 0.15)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.borderColor = 'var(--border-light)';
        e.currentTarget.style.boxShadow = 'none';
      }}
    >
      <div style={{
        position: 'absolute',
        top: 0,
        right: 0,
        width: '100px',
        height: '100px',
        background: 'radial-gradient(circle at top right, rgba(212, 175, 55, 0.05) 0%, transparent 70%)',
        pointerEvents: 'none'
      }} />
      <div style={{ marginBottom: '24px', position: 'relative', zIndex: 1 }}>
        <div style={{
          width: '56px',
          height: '56px',
          background: 'linear-gradient(135deg, rgba(212, 175, 55, 0.1) 0%, rgba(139, 123, 168, 0.05) 100%)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: '0px',
          border: '1px solid rgba(212, 175, 55, 0.2)'
        }}>
          <IconComponent size={28} strokeWidth={1.5} color="var(--accent-gold)" />
        </div>
      </div>
      <h3 className="heading-3" style={{ marginBottom: '12px', position: 'relative', zIndex: 1 }}>
        {service.title}
      </h3>
      <p className="body-regular" style={{ color: 'var(--text-secondary)', position: 'relative', zIndex: 1 }}>
        {service.description}
      </p>
    </div>
  );
};

const Services = () => {
  return (
    <section className="section-padding" style={{ 
      background: 'var(--bg-secondary)',
      position: 'relative',
      overflow: 'hidden'
    }}>
      <div className="luxury-container" style={{ position: 'relative', zIndex: 1 }}>
        <div style={{ textAlign: 'center', marginBottom: '60px' }}>
          <div style={{
            display: 'inline-block',
            padding: '6px 16px',
            background: 'rgba(139, 123, 168, 0.1)',
            border: '1px solid rgba(139, 123, 168, 0.2)',
            marginBottom: '16px',
            borderRadius: '0px'
          }}>
            <span style={{ 
              fontSize: '11px', 
              fontWeight: '600', 
              color: 'var(--accent-purple)', 
              letterSpacing: '1.5px',
              textTransform: 'uppercase'
            }}>
              What We Offer
            </span>
          </div>
          <h2 className="heading-1" style={{ marginBottom: '16px' }}>
            Our Services
          </h2>
          <p className="body-large" style={{ color: 'var(--text-secondary)', maxWidth: '700px', margin: '0 auto' }}>
            Comprehensive tax preparation services tailored to your unique financial situation
          </p>
        </div>
        <div className="grid-services">
          {mockServices.map((service) => (
            <ServiceCard key={service.id} service={service} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;